import ImageMapper from 'react-img-mapper';

import formatName from '../modules/format-name';
import libravatarImage from '../modules/libravatar-image.mjs';

import areav1 from '../area-v1.json';
import areav2 from '../area-v2.json';
import areav3 from '../area-v3.json';
import areav4 from '../area-v4.json';
import areav5 from '../area-v5.json';
import areav6 from '../area-v6.json';

const areas = {
    '1': areav1,
    '2': areav2,
    '3': areav3,
    '4': areav4,
    '5': areav5,
    '6': areav6,
};

const identityReplacements = {
    'madeleine.moller': 'madeleine.moller-stahl',
};

// Picks a random point within a room polygon's bounding box — same
// approach as MarauderMap, kept simple rather than a true point-in-polygon
// test since avatars landing a little off a wall edge is harmless here.
function getRandomPointInPolygon(coords) {
    const minX = Math.min(...coords.filter((_, index) => index % 2 === 0));
    const maxX = Math.max(...coords.filter((_, index) => index % 2 === 0));
    const minY = Math.min(...coords.filter((_, index) => index % 2 === 1));
    const maxY = Math.max(...coords.filter((_, index) => index % 2 === 1));

    const x = Math.random() * (maxX - minX) + minX;
    const y = Math.random() * (maxY - minY) + minY;

    return { x, y };
}

// Renders a single floor's plan with the people currently on that floor
// placed inside their room's polygon. Used both by the full Marauder view
// (one floor at a time, stacked) and by the floor-plan overlay reachable
// from a floor card in the Våningsplan sort mode.
const FloorMap = function({floorNumber, validDevices, displayNames}){
    const avatarSize = 40;
    const url = `${process.env.PUBLIC_URL}/images/map-v${floorNumber}.png`;
    const map = {
        name: `map-v${floorNumber}`,
        areas: areas[floorNumber],
    };

    return (
        <div className="floor-map map-wrapper in-view">
            <ImageMapper
                src={url}
                map={map}
            />
            {validDevices.map((device) => {
                if (device.identity in identityReplacements) {
                    device.identity = identityReplacements[device.identity];
                }

                if (device.ap.location[0] !== floorNumber.toString()) {
                    return null;
                }

                const deviceArea = areas[floorNumber].find((area) => area.rooms.includes(device.ap.location));

                if (!deviceArea) {
                    return null;
                }

                const position = getRandomPointInPolygon(deviceArea.coords);

                return (
                    <div
                        className="device-wrapper"
                        title={device.identity}
                        key={device.mac}
                        style={{
                            top: `${position.y - avatarSize / 2}px`,
                            left: `${position.x - avatarSize / 2}px`,
                            width: avatarSize,
                            height: avatarSize,
                        }}
                    >
                        <div className="person-name">
                            { displayNames?.get( device.identity ) ?? formatName( device.identity ) }
                        </div>
                        <div className="last-seen-wrapper">
                            <img
                                alt={device.identity}
                                src={libravatarImage(`${device.identity}@stendahls.se`)}
                            />
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

export default FloorMap;
